/** Public contact placeholders — replace before production if needed. */
export const CONTACT_EMAIL = "hello@locketapp.com";
export const PRIVACY_EMAIL = "privacy@locketapp.com";
